import { render, staticRenderFns } from "./Dragable-List.vue?vue&type=template&id=28487b6a&"
import script from "./Dragable-List.vue?vue&type=script&lang=js&"
export * from "./Dragable-List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports